import type { MessageDescriptor } from 'react-intl-next';

import { examplesSectionMessages } from '../../ui/modal/examples-section/messages';

function isMessageDescriptor(value: unknown): value is MessageDescriptor {
	return (
		typeof value === 'object' &&
		value !== null &&
		'id' in value &&
		'defaultMessage' in value
	);
}

/**
 * Default strings for examples-section copy until Traduki publishes matching keys in
 * `@atlassian/afm-i18n-platform-growth-edition-benefits-modal`. Merged into Intl defaultMessages.
 */
export const examplesSectionFallbackMessages: Record<string, string> = Object.fromEntries(
	Object.values(examplesSectionMessages)
		.filter(isMessageDescriptor)
		.map((d) => {
			const msg = d.defaultMessage;
			return [d.id, typeof msg === 'string' ? msg : String(msg)];
		}),
);
